import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pressure-template',
  templateUrl: './pressure-template.component.html',
  styleUrls: ['./pressure-template.component.less']
})
export class PressureTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
